import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, ProtectedRoute } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import CoursePlayer from "@/pages/CoursePlayer";
import Certificates from "@/pages/Certificates";
import CertificateValidate from "@/pages/CertificateValidate";
import Library from "@/pages/Library";
import MyTrack from "@/pages/MyTrack";
import Matrix from "@/pages/Matrix";
import Ranking from "@/pages/Ranking";
import Notifications from "@/pages/Notifications";
import Recycling from "@/pages/Recycling";
import CollaboratorDetail from "@/pages/CollaboratorDetail";
import ComplianceAlerts from "@/pages/ComplianceAlerts";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminOrg from "@/pages/admin/AdminOrg";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminAi from "@/pages/admin/AdminAi";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/validate/:code" element={<CertificateValidate />} />

          {/* Authenticated layout */}
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CoursePlayer />} />
            <Route path="/my-track" element={<MyTrack />} />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/library" element={<Library />} />
            <Route path="/matrix" element={<ProtectedRoute roles={["master_admin", "company_admin", "manager"]}><Matrix /></ProtectedRoute>} />
            <Route path="/ranking" element={<Ranking />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/recycling" element={<Recycling />} />
            <Route path="/collaborators/:id" element={<ProtectedRoute roles={["master_admin", "company_admin", "manager", "employee"]}><CollaboratorDetail /></ProtectedRoute>} />
            <Route path="/alerts" element={<ProtectedRoute roles={["master_admin", "company_admin", "manager"]}><ComplianceAlerts /></ProtectedRoute>} />

            <Route path="/admin/users" element={<ProtectedRoute roles={["master_admin", "company_admin"]}><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/organization" element={<ProtectedRoute roles={["master_admin", "company_admin"]}><AdminOrg /></ProtectedRoute>} />
            <Route path="/admin/courses" element={<ProtectedRoute roles={["master_admin", "company_admin"]}><AdminCourses /></ProtectedRoute>} />
            <Route path="/admin/ai" element={<ProtectedRoute roles={["master_admin", "company_admin"]}><AdminAi /></ProtectedRoute>} />
            <Route path="/admin/companies" element={<ProtectedRoute roles={["master_admin"]}><AdminCompanies /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute roles={["master_admin", "company_admin"]}><AdminSettings /></ProtectedRoute>} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
